import { login } from "@lib/data/customer"
import { LOGIN_VIEW } from "@modules/account/templates/login-template"
import ErrorMessage from "@modules/checkout/components/error-message"
import { SubmitButton } from "@modules/checkout/components/submit-button"
import Input from "@modules/common/components/input"
import { useActionState } from "react"
import { useFrontendPreferences } from "@lib/frontend-preferences"

type Props = {
  setCurrentView: (view: LOGIN_VIEW) => void
}

const Login = ({ setCurrentView }: Props) => {
  const [message, formAction] = useActionState(login, null)
  const { locale, t } = useFrontendPreferences()

  return (
    <div
      className="sahil-account-login max-w-sm w-full flex flex-col items-center"
      data-testid="login-page"
      dir={locale === "fa" ? "rtl" : "ltr"}
    >
      <h1 className="sahil-account-login__title text-large-semi uppercase mb-6">{t.account.signInTitle}</h1>
      <p className="sahil-account-login__intro text-center text-base-regular mb-8">
        {t.account.signInBody}
      </p>
      {message?.state === "verification_required" && (
        <div
          className="w-full mb-6 text-center text-base-regular text-ui-fg-base bg-ui-bg-subtle border border-ui-border-base rounded-rounded p-4"
          data-testid="login-verification-message"
        >
          {t.account.verificationEmailSent} <strong dir="ltr">{message.email}</strong>. {t.account.verificationSignInPrompt}
        </div>
      )}
      <form className="w-full" action={formAction}>
        <div className="flex flex-col w-full gap-y-2">
          <Input
            label={t.account.email}
            name="email"
            type="email"
            title={t.account.emailValidation}
            autoComplete="email"
            required
            data-testid="email-input"
          />
          <Input
            label={t.account.password}
            name="password"
            type="password"
            autoComplete="current-password"
            required
            data-testid="password-input"
          />
        </div>
        <ErrorMessage
          error={message?.state === "error" ? message.error : null}
          data-testid="login-error-message"
        />
        <SubmitButton data-testid="sign-in-button" className="w-full mt-6">
          {t.account.signIn}
        </SubmitButton>
      </form>
      <span className="sahil-account-login__switch text-center text-small-regular mt-6">
        {t.account.notMember}{" "}
        <button
          onClick={() => setCurrentView(LOGIN_VIEW.REGISTER)}
          className="underline"
          data-testid="register-button"
        >
          {t.account.joinUs}
        </button>
        .
      </span>
    </div>
  )
}

export default Login
